import cn from 'classnames';
import PropTypes from 'prop-types';

import { Row, RowSpan } from 'components/checkout/caap/Layout';
import { getPaymentTypeIcon } from 'components/checkout/CheckoutUtils';
import { TextField } from 'components/Mdl';
import { getFieldFocusEvents } from 'helpers/CheckoutUtils';
import css from 'styles/components/checkout/caap/payment/paymentlist/needsConfirmation.scss';

const fieldFocusEvents = getFieldFocusEvents(css.hasFormElementWithFocus);

const NeedsConfirmation = ({ showCCIVRPayment, paymentInstrumentId, type }, { testId }) => {
  const inputId = `confirmCard-${paymentInstrumentId}`;
  const expiredStyle = cn({ [css.expired]: type.isExpired });
  return (
    <Row>
      <RowSpan desktopSpan="5" mobileSpan="12">
        <RowSpan desktopSpan="2" mobileSpan="0">
          <label htmlFor={inputId}>
            {getPaymentTypeIcon(type.paymentType)}
          </label>
        </RowSpan>
        <RowSpan desktopSpan="9" mobileSpan="11">
          <div className={css.form}>
            <div { ...fieldFocusEvents } className={`${css.formInputWrapper} ${css.solo}`}>
              <TextField
                disabled={!!showCCIVRPayment}
                id={inputId}
                placeholder={`ending in ${type.addCreditCardNumber}`}
                data-test-id={testId('confirmCCNumberInput')} />
            </div>
          </div>
        </RowSpan>
      </RowSpan>
      <RowSpan desktopSpan="4" mobileSpan="0">
        <div className={css.forceWrap}>
          <label htmlFor={inputId}>
            {type.fullName}
          </label>
        </div>
      </RowSpan>
      <RowSpan desktopSpan="3" mobileSpan="0">
        <div className={expiredStyle}>
          <label htmlFor={inputId}>
            {type.expirationMonth}/{type.expirationYear}
          </label>
        </div>
      </RowSpan>
    </Row>
  );
};

NeedsConfirmation.contextTypes = {
  testId: PropTypes.func
};

export default NeedsConfirmation;
